import '../../styles/SignInUp.css';
import { useLocation } from 'react-router-dom';

function RegisterVerificationWindow() {
  const location = useLocation();
  const userEmail = location.state?.email || "adres e-mail";

  return (
    <div className="register-wrapper">
      <div className="register-card">
        <h2 className="register-title">
          Potwierdź rejestrację
        </h2>
        <p className="register-subtitle">Kliknij link aktywacyjny, który przyszedł na poniższy adres e-mail:</p>
         <strong style={{"color" : "#00E5FF", "fontSize" : "large"}}>{userEmail}</strong>

      </div>
    </div>
  );
}

export default RegisterVerificationWindow;